import type { RotaWarning } from "../engine/rules";

/** A warning as one short line, e.g. "Only 8h rest (min 11h)". */
export function warningText(w: RotaWarning, t: (key: string) => string) {
  return t(`workday.warn.${w.kind}`)
    .replace("{value}", String(w.value ?? ""))
    .replace("{limit}", String(w.limit ?? ""));
}
